import { uat } from "../../../abraj-shared/src/public-api";

export const environment = {
    production: false,
    config:uat

}
